module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/ogp-e5e0e8f082c6e263622da25e21777ab7.webp";